import React from "react";
import { VariantHeroBlock } from "tsi-common-react/src/apps/configurator/VariantHeroBlock";
import { makeStyleguideTemplate } from "tsi-common-react/src/styleguide/makeStyleguideTemplate";

import { templates } from "@reactivated";

import { toolboxComponentsMap } from "../blocks/toolboxComponentsMap";
import { homePageBodyComponentsMap } from "../components/HomePageBody";
import { homePageHeroOptionsComponentsMap } from "../components/HomePageHeroOptions";
import { homePageHeroSidekickComponentsMap } from "../components/HomePageHeroSidekick";
import { productDisplayPageBodyComponentsMap } from "../components/ProductDisplayPageBody";
import { productFilterGridPageBodyComponentsMap } from "../components/ProductFilterGridPageBody";
import { StyleguideChrome } from "../components/StyleguideChrome";

// ``pdp_hero`` is not a component-map dispatch in production: PDPHeroTemplate
// picks the winning variant and renders <VariantHeroBlock> directly. This small
// inline map lets the styleguide drive the same component under the assembly's
// ``variant_hero_block`` StreamField key.
const pdpHeroComponentsMap = {
    variant_hero_block: VariantHeroBlock,
};

const registry = {
    toolbox: toolboxComponentsMap,
    home: homePageBodyComponentsMap,
    home_hero: homePageHeroOptionsComponentsMap,
    home_sidekick: homePageHeroSidekickComponentsMap,
    pdp: productDisplayPageBodyComponentsMap,
    pdp_hero: pdpHeroComponentsMap,
    filter_grid: productFilterGridPageBodyComponentsMap,
};

const StyleguideBlocks = makeStyleguideTemplate(registry);

export const Template = (
    props: templates.StyleguideBlockTemplate,
): React.JSX.Element => {
    const inner = (
        <StyleguideBlocks
            block={props.block}
            map_key={props.map_key}
            bg_color={props.bg_color}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? inner : <div id="block-tester">{inner}</div>}
        </StyleguideChrome>
    );
};
